const initialState = {
    connected : false,
    connecting : true,
    authedUser : null,
    authChecked : false,
    userLocation : null,
    user : {
        email :'',// 'mikejstrange@gmail.com',//null,
        firstName: '', //"Mike",//null,
        lastName : '' // "S"//null
    }
}

export default (state = initialState, action) => {
    let attrs = {};

    switch (action.type) {
        case 'FIREBASE_INITIALISING':
            return { ...state, connected : false, connecting : true }
        case 'FIREBASE_CONNECTED':
            return { ...state, connected : true, connecting : false }
        case 'FIREBASE_AUTHSTATE_CHANGE':
            return { ...state, authedUser : action.payload, authChecked : true  }
        case 'UPDATE_USER_LOCATION':
            return {...state, userLocation: action.payload}
        case 'AUTH_LOGGED_OUT':
            return { ...state, authUser : null }

        case 'UPDATE_INVENTORY_PLEDGE_USER':
            attrs.user = {...state.user};
            attrs.user[action.payload.key] = action.payload.value;
            return {...state, ...attrs}
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/appReducer.js